exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#invoicelink{\r\n  display: none;\r\n  text-align: center;\r\n  margin: 10px 0;\n}\n@media only screen and (max-width: 768px) {\r\n  /* For mobile phones: */\n.invoice-view-page {\r\n    padding-left: unset !important;\r\n    /* padding-left: unset; */\n}\n.invoice-view-page .invoice-sidebar{\r\n  display: none;\n}\n#invoicelink{\r\n  display: block;\n}\r\n /* .page-header .page-actions{\r\n  display: none;\r\n } */\n}\n.invoice-view-page .invoice-sidebar{\r\n  left: 0px;\r\n  /* width: 500px; */\n}\r\n\r\n\r\n\r\n\r\n", ""]);

// exports
